import { useRef, useState } from 'react';
import { toPng } from 'html-to-image';
import { Document, Page, Text, View, Image, StyleSheet, Font, pdf } from '@react-pdf/renderer';

const FeedbackFormPdf = ({ feedbackFormRef, feedbackFormPdfName }) => {
    const hiddenPdfContainerRef = useRef();
    const [pdfLoading, setPdfLoading] = useState(false);

    Font.register({
        family: 'Poppins',
        src: 'https://fonts.gstatic.com/s/poppins/v21/pxiEyp8kv8JHgFVrFJA.ttf'
    });

    // PDF Styles
    const pdfStyles = StyleSheet.create({
        title: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063' },
        text: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063', fontSize: 10 },
        textUnderline: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063', fontSize: 12, textDecoration: 'underline' },
        page: { flexDirection: 'column', backgroundColor: '#E4E4E4' },
        section: { marginLeft: '30px', marginRight: '30px', paddingTop: '35px', paddingBottom: '25px' },
        image: { objectFit: 'scale-down', paddingTop: 25, paddingRight: 3, paddingBottom: 25, paddingLeft: 3 },
        imageCont: { maxHeight: '75vh', maxWidth: '100vw', marginTop: '40px' },
        detailsSection: { paddingLeft: 3, paddingRight: '130px', marginTop: '20px', },
        singleOutcome: { marginTop: 10 },
        logo: { width: 100, position: 'absolute', top: '30px', right: 0 },
        footer: { position: 'absolute', top: '91vh', left: 0, maxWidth: '100vw' },
        footerText: { fontSize: '8pt', color: '#5c5c5c' }
    });

    // PDF document
    const PdfDocument = ({ feedbackFormImage }) => (
        <Document>
            <Page size="A4">
                <View style={pdfStyles.section}>
                    <Image style={pdfStyles.logo} src={require('../../assets/SCP-logo.jpg')} />

                    <View style={pdfStyles.imageCont}>
                        {feedbackFormImage && <Image style={pdfStyles.image} src={feedbackFormImage} />}
                    </View>

                    <View style={pdfStyles.footer}>
                        <Text style={pdfStyles.footerText}>
                            School Consultancy Programme is part of Tutor Your Child Ltd (registered 13378546).
                            Assessments results are calculated by analysing the assessment information available to
                            us at the time using our experience and qualifications. This may not represent the views
                            of all agencies or individuals, and should be used in conjunction with other information available.
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    );

    // Generate and auto-download
    const generateAndDownloadPdf = async () => {
        setPdfLoading(true);
        try {
            // capture screenshot of form
            const dataUrl = await toPng(feedbackFormRef.current, {
                backgroundColor: '#ffffff',
                pixelRatio: 2
            });

            // create pdf blob
            const blob = await pdf(<PdfDocument feedbackFormImage={dataUrl} />).toBlob();

            // trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = feedbackFormPdfName || 'feedback-form.pdf';
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <>
            <button onClick={generateAndDownloadPdf} className="pdfButton" disabled={pdfLoading}>
                {pdfLoading ? 'Generating PDF...' : 'Download PDF'}
            </button>

            <div className="feedback-form-hidden-pdf">
                <div ref={hiddenPdfContainerRef} />
            </div>
        </>
    );
};

export default FeedbackFormPdf;
